import { Button, InlineError, LegacyStack, Tag, Text } from '@shopify/polaris'
import React, { useCallback } from 'react'

import { gidToId, useToggle } from '../common/helpers'
import { LegacyHelpIcon } from '../common/HelpIcon'
import { ProductModal, ProductResult } from '../common/ProductModal'
import {
  WorkflowAction,
  workflowActionLabels,
  WorkflowProductDataType,
} from '../common/workflow-models'

export const RemoveProductAction = ({
  params,
  onChange,
  index,
  error,
}: {
  params: WorkflowProductDataType
  onChange: (action: WorkflowAction, index: number) => any
  index: number
  error: string | null
}) => {
  const [productModalActive, toggleProductModalActive] = useToggle(false)

  const handleUpdate = useCallback(
    (result: ProductResult) => {
      onChange(['remove-product', [gidToId(result.id), result.title]], index)
      toggleProductModalActive()
    },
    [index, onChange, toggleProductModalActive]
  )

  return (
    <>
      <LegacyStack vertical>
        <Text variant="headingSm" as="h2">
          {workflowActionLabels['remove-product']}
          <LegacyHelpIcon>
            Line items that match the selected product will be removed from the subscription.
            Removal will fail if there are no line items left in the subscription.
          </LegacyHelpIcon>
        </Text>

        {params.length === 0 && (
          <Text as="span" tone="subdued">
            No product selected
          </Text>
        )}

        {params[0] && <Tag key={params[0]}>{params[1]}</Tag>}

        <Button onClick={toggleProductModalActive} size="slim">
          Select product
        </Button>
        {error && <InlineError message={error} fieldID="" />}
      </LegacyStack>
      <ProductModal
        open={productModalActive}
        onClose={toggleProductModalActive}
        onSelect={handleUpdate}
      />
    </>
  )
}
